import React, { useEffect, useRef } from "react";
import {
  ImageContainer,
  Image,
  QuoteContainer,
  Wrapper,
  ImageLink,
} from "../styles/components/Galleries/Transitional";
import { mm } from "../styles/variables/MatchMedia";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";
import animations from "./Animations";

const GalleryTransitional = () => {
  const wrapperRef = useRef(null);
  const imageRef = useRef(null);
  const quoteRef = useRef(null);

  useEffect(() => {
    const mediaMatcher = mm();
    mediaMatcher.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
      animations
        .timeline({
          scrollTrigger: {
            trigger: wrapperRef.current,
            start: "top top",
            end: !context.isMobile ? "bottom bottom" : "+=500px",
            scrub: true,
          },
        })
        .to(
          imageRef.current,
          {
            opacity: 0.2,
            scale: 0.8,
          },
          0
        );
    });
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      <ImageContainer ref={imageRef}>
        <ImageLink
          href="https://www.highsnobiety.com/en-de/shop/product/highsnobiety-magazine-winter-2023/"
          target="_blank"
        >
          <Image src="https://www.datocms-assets.com/40484/1701116184-hx33_cover_asap_rocky-1.png" />
        </ImageLink>
      </ImageContainer>
      <QuoteContainer ref={quoteRef}>
        <Image
          src="https://www.datocms-assets.com/40484/1701090999-rectangle-81.png"
          $blend
        />
        <Image
          src="https://www.datocms-assets.com/40484/1701255665-quote_01_style-1.png"
          $desktop
        />
        <Image
          src="https://www.datocms-assets.com/40484/1701256638-01_quote_mobile.png"
          $mobile
        />
      </QuoteContainer>
    </Wrapper>
  );
};

export default GalleryTransitional;
